"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _text = _interopRequireDefault(require("@ux/text"));
var _paragraph = _interopRequireDefault(require("@site/pattern-library-core/paragraph"));
/**
 * Local Imports
 */

const Description = /*#__PURE__*/(0, _react2.styled)(_paragraph.default)({
  name: "Description",
  class: "pl-do2f5nc"
});

/**
 * TextItem Component.
 *
 * @param {Object} props React props
 * @param {String}  props.description Description
 * @param {String}  props.phoneNumber Phone Number
 * @returns {React.ReactElement} TextItem Component
 * @public
 */

function TextItem({
  _name = 'text-item',
  description,
  phoneNumber
}) {
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    "data-cy": "text-item"
  }, _patternLibraryUtils.tracking.create(_name, false, true)), description && /*#__PURE__*/_react.default.createElement(Description, {
    dataCy: "item-description",
    text: description
  }), phoneNumber && /*#__PURE__*/_react.default.createElement(_text.default.p, {
    as: "title",
    dataCy: "item-phone-number",
    text: phoneNumber
  }));
}
var _default = exports.default = TextItem;
TextItem.propTypes = {
  _name: _propTypes.default.string,
  description: _propTypes.default.string,
  phoneNumber: _propTypes.default.string
};